@if (has_tvpi) {
  <div class="app__form--attribute mb-4">
    <div>
      <p class="app__form--attribute--title">Performance Summary</p>
      @if (has_tvpi) {
        <div class="app__form--attribute--card h-14 mt-2">
          <div class="app__between--justified--content">
            <p class="app__form--attribute--title text-sm font-normal">
              Total Value to Paid In (TVPI)
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [matTooltip]="' (market value + Distributions) / Capital Calls'"
                >
                <g clip-path="url(#clip0_11214_6432)">
                  <path
                    d="M9.66699 6.33317H11.3337V7.99984H9.66699V6.33317ZM10.5003 14.6665C10.9587 14.6665 11.3337 14.2915 11.3337 13.8332V10.4998C11.3337 10.0415 10.9587 9.6665 10.5003 9.6665C10.042 9.6665 9.66699 10.0415 9.66699 10.4998V13.8332C9.66699 14.2915 10.042 14.6665 10.5003 14.6665ZM10.5003 2.1665C5.90033 2.1665 2.16699 5.89984 2.16699 10.4998C2.16699 15.0998 5.90033 18.8332 10.5003 18.8332C15.1003 18.8332 18.8337 15.0998 18.8337 10.4998C18.8337 5.89984 15.1003 2.1665 10.5003 2.1665ZM10.5003 17.1665C6.82533 17.1665 3.83366 14.1748 3.83366 10.4998C3.83366 6.82484 6.82533 3.83317 10.5003 3.83317C14.1753 3.83317 17.167 6.82484 17.167 10.4998C17.167 14.1748 14.1753 17.1665 10.5003 17.1665Z"
                    fill="#25508E"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_11214_6432">
                      <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </p>
              <p class="app__form--attribute--add--btn">
                <span class="font-bold text-sm text-k-black"> {{ tvpi ?? '0.00' }} </span>
              </p>
            </div>
          </div>
        }
      </div>
    </div>
  }
